import React, { useCallback, useState } from 'react';
import { IsetToolbar } from '../CustomToolBar';
import { ToolbarButton, ToolbarWrapper } from '../../QuillToolbarStyles';
import Icon from '@components/dataDisplay/Icons/Icon';
import DropdownWrapper, { dropdownDirMap } from '@components/wrapper/DropdownWrapper';
import EmoticonList from '@template/Emoticon/EmoticonList';
import VideoInsertDropdown from '../../QuillCustomVideo/VideoInsertDropdown';


type Props = {
  quillRef?: any;
  setToolbar?: IsetToolbar;
  emojiDirection?: keyof typeof dropdownDirMap | undefined;
  collectionPath?: string;
  setVideoURLList?: (updater: (prev: string[]) => string[]) => void;
  videoDropdownDirection?: 'up' | 'down';
};
function ToolbarSec3({ setToolbar, quillRef, emojiDirection, collectionPath, setVideoURLList, videoDropdownDirection = 'down' }: Props) {
  const { list, link, image, file, emoji, video } = setToolbar || {};
  const [showEmoji, setShowEmoji] = useState(false);
  const [showVideoInsert, setShowVideoInsert] = useState(false);

  const toggleEmoji = useCallback(() => {
    if (!quillRef || !quillRef.current) return;
    setShowEmoji(!showEmoji);
  }, [showEmoji, quillRef]);

  const toggleVideoInsert = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setShowVideoInsert((prev) => !prev);
    },
    [],
  );

  const handleEmojiClick = (emojiImage) => {
    if (!quillRef || !quillRef.current) return;
    const editor = quillRef.current.getEditor();
    const selection = editor.getSelection();
    if (selection) {
      const cursorPosition = selection.index;
      // 원하는 이미지 크기 설정
      const height = '54px'; // 원하는 높이
      const imageHTML = `<img src="${emojiImage}" style=" height: ${height};" />`;

      // editor.insertEmbed(cursorPosition, 'image', emojiImage);
      editor.clipboard.dangerouslyPasteHTML(cursorPosition, imageHTML);
    }
  };

  // 이모지를 클릭할 때 호출되는 함수
  const handleEmojiSelection = useCallback(
    (emoji) => {
      if (!quillRef || !quillRef.current) return;
      handleEmojiClick(emoji); // 선택된 이모지를 부모 컴포넌트의 함수에 전달
      toggleEmoji(); // 이모지 선택 후 드롭다운을 닫음
    },
    [toggleEmoji, quillRef],
  );

  return (
    <>
      {(link || image || file || emoji || video) && (
        <ToolbarWrapper>
          {image && (
            <ToolbarButton
              className="ql-image"
              data-tooltip="이미지(30MB 이하)"
            />
          )}

          {video && (
            <ToolbarButton
              className="ql-video"
              data-tooltip="동영상 삽입"
              style={{ position: 'relative' }}
              onClick={toggleVideoInsert}
            >
              {showVideoInsert && quillRef && (
                <VideoInsertDropdown
                  quillRef={quillRef}
                  collectionPath={collectionPath || 'posting'}
                  setVideoURLList={setVideoURLList}
                  onClose={() => setShowVideoInsert(false)}
                  direction={videoDropdownDirection}
                />
              )}
            </ToolbarButton>
          )}
          {link && (
            <ToolbarButton
              className="ql-link"
              data-tooltip="링크 걸기"
            />
          )}

          {file && (
            <ToolbarButton
              className="ql-fileUpload"
              data-tooltip="파일 첨부(30MB 이하)"
            />
          )}

          {emoji && (
            <>
              <ToolbarButton
                className="ql-emoji"
                data-tooltip="이모티콘"
                style={{ position: 'relative' }}
                onClick={toggleEmoji}
              >
                <Icon name="Smile20" />
                {showEmoji && (
                  <DropdownWrapper
                    className="ql-emoji-list"
                    direction={emojiDirection || 'bottomLeft'}
                    style={{ width: 400, maxHeight: 300 }}
                  >
                    <EmoticonList handleClick={handleEmojiSelection} />
                  </DropdownWrapper>
                )}
              </ToolbarButton>
            </>
          )}
        </ToolbarWrapper>
      )}
    </>
  );
}

export default ToolbarSec3;
